import { type FC, useState } from 'react';
import { Bar, BarChart, Cell, ResponsiveContainer, XAxis, YAxis } from 'recharts';

import { colors } from '@/design-system/colors';
import { radius } from '@/design-system/radius';

import { formatAxisDate } from './bar-chart';
import { CarouselCardChartArea, CarouselCardContainer } from './carousel-card.styled';
import { CarouselCardTitle } from './carousel-card-header';
import type { CardProps } from './common';

const AXIS_FONT_SIZE = 10;

export const CarouselBarCard: FC<{ card: CardProps }> = ({ card }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <CarouselCardContainer>
      <CarouselCardTitle title={card.title} value={card.value} delta={card.delta} />

      <CarouselCardChartArea>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={card.chartData ?? []}
            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <XAxis
              dataKey="date"
              interval="preserveStartEnd"
              tickFormatter={formatAxisDate}
              tick={{ fill: colors.text.secondary, fontSize: AXIS_FONT_SIZE }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis hide domain={[0, 'dataMax']} />
            <Bar
              dataKey="count"
              radius={radius[4]}
              onMouseOver={(_, index) => setActiveIndex(index)}
            >
              {(card.chartData ?? []).map((_, index) => (
                <Cell
                  key={index}
                  fill={index === activeIndex ? colors.brand.solid : colors.background.overlay}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CarouselCardChartArea>
    </CarouselCardContainer>
  );
};
